<script setup lang="ts">
import { computed } from 'vue'
import { siFacebook, siInstagram, siLine } from 'simple-icons'
import type { Channel, ConversationKind } from '../../api/types'
import Icon from './Icon.vue'

/** Official brand marks from simple-icons (CC0), in each brand's own colour. Web chat has no platform → globe. */
const BRAND = { fb: siFacebook, ig: siInstagram, line: siLine } as const

// bare: inside a link that carries the name itself (components/chat/PlatformLink.vue) — no own role/title
const props = defineProps<{ channel: Channel; kind?: ConversationKind; bare?: boolean }>()
const brand = computed(() => (props.channel === 'web' ? null : BRAND[props.channel]))
const isComment = computed(() => props.kind === 'comment')
const label = computed(() => (brand.value ? brand.value.title : 'แชทบนเว็บ') + (isComment.value ? ' · คอมเมนต์' : ''))
</script>

<template>
  <span
    class="chl"
    :class="{ 'is-cmt': isComment }"
    :role="bare ? undefined : 'img'"
    :aria-label="bare ? undefined : label"
    :title="bare ? undefined : label"
    :aria-hidden="bare ? 'true' : undefined"
  >
    <svg v-if="brand" class="chl-logo" viewBox="0 0 24 24" aria-hidden="true" :style="{ color: '#' + brand.hex }">
      <path :d="brand.path" fill="currentColor" />
    </svg>
    <span v-else class="chl-web"><Icon name="globe" /></span>
    <span v-if="isComment" class="chl-cmt"><Icon name="chat" /></span>
  </span>
</template>

<style scoped>
.chl {
  position: relative;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}
.chl-logo {
  display: block;
  width: 18px;
  height: 18px;
}
.chl-web {
  display: inline-flex;
  color: #56655e;
}
.chl-web :deep(.ic) {
  width: 18px;
  height: 18px;
}
/* comment under a post/ad: small speech bubble on the platform logo */
.chl-cmt {
  position: absolute;
  right: -6px;
  bottom: -5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  color: #3e4d46;
  box-shadow: 0 0 0 1px #e1e8e4;
}
.chl-cmt :deep(.ic) {
  width: 9px;
  height: 9px;
  stroke-width: 2.4;
}
</style>
